import { isPlainObject } from 'lodash';
import { ITranslationKey } from '../../ITranslationKey';
import { ITranslationSchema } from '../TranslationSchema';
import {
  BaseTranslationSchema,
  ITranslationUpdateContext,
  TranslationSchemaType,
} from './BaseTranslationSchema';

export class TranslationObjectSchema extends BaseTranslationSchema {
  type = TranslationSchemaType.Object;
  public prefix?: string;

  constructor(public shape: Record<string, ITranslationSchema>) {
    super();
  }

  withRoot(prefix: string) {
    this.prefix = prefix;
    return this;
  }

  private normalizePrefix(prefix: string) {
    if (prefix === '') {
      return this.prefix ?? '';
    }

    return prefix;
  }

  extract(value: any, path = '', prefix = ''): ITranslationKey[] {
    const object = value as Record<string, any>;
    if (!object || !isPlainObject(object)) return [];

    return Object.keys(this.shape).flatMap(key => {
      const subschema = this.shape[key];
      const subvalue = object[key];
      if (!subvalue) return [];

      const subprefix = subschema.shouldOmitKey
        ? `${this.normalizePrefix(prefix)}`
        : `${this.normalizePrefix(prefix)}.${key}`;

      return subschema.extract(subvalue, `${path}.${key}`, subprefix);
    });
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ) {
    const object = value as Record<string, any>;
    if (!object || !isPlainObject(object)) return;

    Object.keys(this.shape).forEach(key => {
      const subschema = this.shape[key];
      const subvalue = object[key];
      if (!subvalue) return;

      const subprefix = subschema.shouldOmitKey
        ? `${this.normalizePrefix(prefix)}`
        : `${this.normalizePrefix(prefix)}.${key}`;

      subschema.translateValue(subvalue, `${path}.${key}`, subprefix, ctx);
    });
  }
}
